import { render, staticRenderFns } from "./OrderItemsArchive.vue?vue&type=template&id=7ab9d6e0"
import script from "./OrderItemsArchive.vue?vue&type=script&lang=js"
export * from "./OrderItemsArchive.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsArchive.vue?vue&type=style&index=0&id=7ab9d6e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports